/** @format */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Layout, Menu, Button ,Col} from "antd";
import _sortBy from "lodash/sortBy";
import _cloneDeep from "lodash/cloneDeep";

import CheckboxGroup from "./CheckboxGroup";
import SortByFilter from "./SortByFilter";
import { filterApply, filterRemove } from "../../utils/GTMDataLayer";
import { useDebouncedEffect } from "../../utils/useDebouncedEffect";
import { DownOutlined,UpOutlined } from '@ant-design/icons';

const { SubMenu } = Menu;
const { Sider } = Layout;

const OPEN_KEYS = [
  "category",
  "price",
  "key0",
  "key1",
  "key2",
  "key3",
  "key4",
  "key5",
  "key6",
  "key7",
  "key8",
  "key9",
  "key10",
  "key11",
  "key12",
  "key13",
  "key14",
  "key15",
  "key16",
  "key17",
  "key18",
  "key19",
  "key20",
  "key21",
  "key22",
  "key23",
  "key24",
  "key25",
  "key26",
  "key27",
  "key28",
  "key29",
  "key30",
];
const DEFAULT_DRAWER_STATUS = {
  selectedSubMenu: "SORT",
  selectedFacet: {},
};

function ProductFacets({
  userProfile,
  getFilterData,
  onClose,
  queryParams,
  facets,
  currencySymbol,
  currency,
  hideCatFilter,
  isMobile,
  width = "250px",
  handleSortFilter,
  isLoading,
  pageName,
  searchBy = "",
  filterCountMap
}) {
  const getFacets = (passedFacet) => {
    let arrangedFacet = [];
    if (Array.isArray(passedFacet)) {
      passedFacet.map((list) => {
        let newList = _cloneDeep(list);
        if (
          list.aggregateId === "exfactoryListPrice" ||
          list.aggregateId === "range" ||
          list.aggregateId === "exfactorypricerange"
        ) {
          newList.aggregateId = "range";
          let listt = _cloneDeep(list.aggregateList);
          const listLength = listt.length;
          for (let i = 0; i < listLength; i++) {
            let arr = listt[i].value.split("-");
            arr[0] =
              arr[1] === "*"
                ? "> " + currencySymbol + " " + Math.round(arr[0]).toString()
                : currencySymbol + " " + Math.round(arr[0]).toString();
            arr[1] =
              arr[1] === "*"
                ? ""
                : currencySymbol + " " + Math.round(arr[1]).toString();
            listt[i].value = arr[1] ? arr.join(" - ") : arr.join("");
          }
          newList.aggregateList = _cloneDeep(listt);
        }
        arrangedFacet.push(newList);
      });
    }
    const sortedcat = _sortBy(arrangedFacet, "priority");
    // ToDo Check Search and Seller
    return sortedcat;
  };
  const [internalParams, setInternalParams] = useState(queryParams);
  const [openKeys, setOpenKeys] = useState(OPEN_KEYS);
  const [orderedFacets, setOrderedFacets] = useState(getFacets(facets));
  const [drawerStatus, setDrawerStatus] = useState(DEFAULT_DRAWER_STATUS);
  const [expandValue, setExpandValue] = useState(false);
  const [expandMaterial, setExpandMaterial] = useState(false);
  const [modFilterState, setModFilterState] = useState({});
  // const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setInternalParams(queryParams);
  }, [queryParams]);

  useDebouncedEffect(
    () => {
      if (currencySymbol && facets) {
        setOrderedFacets(getFacets(facets));
      }
    },
    [facets, currencySymbol],
    500
  );

  const sortByMobile = (e) => {
    e.preventDefault();
    setDrawerStatus(DEFAULT_DRAWER_STATUS);
    handleSortFilter(e?.target?.value);
    onClose();
  };

  const selectFilter = (e) => {
    let { filterId, checked, filterType } = e.target;
    let paramVal = _cloneDeep(internalParams);
    let currentVal = internalParams[filterType];
    
    // if(filterType === 'f_moqBucket'){
    //   currentVal = '';
    // }
    if(filterType === 'f_moqBucket'){
      currentVal = '';
    }
    let currentValArr = currentVal ? currentVal.split(",") : [];
    if (checked) {
      currentValArr.push(filterId);
      filterApply(filterType, filterId);
    } else {
      currentValArr = currentValArr.filter((item) => item !== filterId);
      filterRemove(filterType, filterId);
    }
    const modValue = currentValArr.join(",");
    const modFilter = {
      ...paramVal,
      [filterType]: modValue
    };
    if (!modValue) {
      delete modFilter[filterType];
    }
    setInternalParams(modFilter);

    if (!isMobile) {
      getFilterData(modFilter, "filter");
    }
  };

  const selectFilterSearch = (e) => {
    let { filterId, checked, filterType } = e.target;
    let paramVal = _cloneDeep(internalParams);
    let currentVal = internalParams[filterType];
    let currentVal1 = internalParams['mobPrice'];
    if(filterType === 'moqbucket'){
      currentVal = '';
    }
    let currentValArr = currentVal ? currentVal.split(",") : [];
    let currentValObj = {};
    if (checked) {
      currentValArr.push(filterId);
      currentValObj = {...currentVal1,[filterId]: checked}
      filterApply(filterType, filterId);
    } else {
      currentValArr = currentValArr.filter((item) => item !== filterId);
      delete currentVal1[filterId];
      currentValObj = currentVal1;
      filterRemove(filterType, filterId);
    }
    const modValue = currentValArr.join(",");
    const modParams = {
      ...paramVal,
      ['mobPrice']: currentValObj,
      [filterType]: modValue
    };
    // {\"attribute\":\"color\",\"value\":\"red\",\"flag\":false,\"numeric\":false}
    const modFilter = {
      ['attribute']: filterType,
      ['values']: (isMobile && filterType == 'range') ? currentValObj : {[filterId]: checked},
      ['flag']: checked,
      ['numeric']: filterType == 'range' ? true : false,
      ['search']: paramVal['search'],
      [filterType]: modValue
    };
    if (!modValue) {
      delete modFilter[filterType];
    }
    setInternalParams(modParams);

    if (!isMobile) {
      getFilterData(modFilter, modParams, "filter");
    } else {
      setModFilterState(modFilter);
    }
  };

  const clearFilter = (e) => {
    e.preventDefault();
    filterRemove("clear all filter", "clear all filter");
    if (isMobile) {
      onClose();
      setDrawerStatus(DEFAULT_DRAWER_STATUS);
    }
    const modQueryParams = _cloneDeep(queryParams);
    if (modQueryParams.range) {
      delete modQueryParams.range;
    }
    if (modQueryParams.endPrice) {
      delete modQueryParams.endPrice;
    }
    if (modQueryParams.startPrice) {
      delete modQueryParams.startPrice;
    }
    if(pageName == 'search-listing'){
      getFilterData({}, {}, "clear");
    }else{
      getFilterData(modQueryParams, "clear");
    }
  };

  const filterSubmit = (e) => {
    e.preventDefault();
    setDrawerStatus(DEFAULT_DRAWER_STATUS);
    if(pageName == 'search-listing'){
      getFilterData(modFilterState, internalParams, "filter");
    }else{
      getFilterData(internalParams, "filter");
    }
    onClose();
  };

  const selectFacetFilter = (filterType, currentValArr) => {
    const paramVal = _cloneDeep(internalParams);
    // const filteredArr = orderedFacets.filter(
    //   (item) => item.aggregateId === filterType
    // );

    // const currentValArr =
    //   filteredArr && filteredArr.length
    //     ? _cloneDeep(filteredArr[0].aggregateList)
    //     : [];
    const modValue = [];
    const modParams = {};
    currentValArr.map((item) => modValue.push(item.value));
    currentValArr.map((item) => modParams[item.value] = true);
    setInternalParams({
      ...paramVal,
      [filterType]: modValue.join(","),
    });

    if (!isMobile) {
      if(pageName == 'search-listing'){
        getFilterData(
          modParams,
          {
            ...paramVal,
            ['attribute']: filterType,
            [filterType]: modValue.join(","),
          },
          "selectFacetLevel"
        );
      } else {
        getFilterData(
          {
            ...paramVal,
            [filterType]: modValue.join(","),
          },
          "filter"
        );
      }
    }
  };

  const clearFacetFilter = (filterType) => {
    const paramVal = _cloneDeep(internalParams);
    delete paramVal[filterType];
    setInternalParams({
      ...paramVal,
    });

    if (!isMobile) {
      if(pageName == 'search-listing' && searchBy === 'product'){
        getFilterData(
          {
            ...paramVal,
            ['attribute']: filterType,
          },
          {...paramVal},
          "clearFacetLevel"
        );
      }else{
        getFilterData(
          {
            ...paramVal,
          },
          "filter"
        );
      }
    }
  };

  const onOpenChange = (openKeys) =>
    setOpenKeys({ openKeys: [...OPEN_KEYS, ...openKeys] });
  return (
    <Sider
      width={width}
      className="site-layout-background product-facet child-w-100"
    >
      {!isLoading && (
        <form className="qa-facets-form">
          <Menu
            mode="inline"
            className="listing-sidebar"
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            selectedKeys={drawerStatus.selectedSubMenu}
            style={{ height: "100%", borderRight: 0, background: "#f9f7f2",paddingBottom:'200px'}}
          >
            <SubMenu
              key="category"
              className="listing-sidebar-left xs-show md-hide"
            >
              <Menu.Item
                key="sortBy"
                onClick={() => setDrawerStatus(DEFAULT_DRAWER_STATUS)}
                className="sort-by left-submenu-list"
              >
                Sort by
              </Menu.Item>
              {orderedFacets.map((facet, key) => {
                if (
                  facet.aggregateId === "f_l1_names" ||
                  (facet.aggregateId === "f_categories" && hideCatFilter) ||
                  (facet.aggregateId === "range" && !userProfile) ||
                  (facet.aggregateId === "exfactorypricerange") ||
                  (facet.aggregateId === "exfactoryListPrice" &&
                    !userProfile) ||
                  facet?.aggregateList?.length === 0
                ) {
                  return <span key={facet.aggregateName}></span>;
                } else {
                  return (
                    <Menu.Item
                      key={facet.aggregateName}
                      onClick={() =>
                        setDrawerStatus({
                          selectedSubMenu: facet.aggregateId,
                          selectedFacet: _cloneDeep(facet),
                        })
                      }
                      className="left-submenu-list"
                    >
                      {(facet.aggregateId === "f_moqBucket" || facet.aggregateId === "moqbucket")
                        ? "Minimum order quantity"
                        : `${facet.aggregateName} 
                           ${
                            facet.aggregateId === "range" ||
                            facet.aggregateId === "exfactorypricerange" ||
                            facet.aggregateId === "exfactoryListPrice"
                              ? "- " + currency
                              : ""
                          }
                          ${
                            filterCountMap && filterCountMap[facet.aggregateId] 
                            ? `(${filterCountMap[facet.aggregateId]})`
                            : ""
                          }`
                        }
                    </Menu.Item>
                  );
                }
              })}
            </SubMenu>
            <li
              className="ant-menu-submenu ant-menu-submenu-inline listing-sidebar-right ant-menu-submenu-open xs-show md-hide"
              role="menuitem"
            >
              <div
                className="ant-menu-submenu-title"
                role="button"
                aria-expanded="true"
                aria-owns="subCategory$Menu"
                aria-haspopup="true"
                title=""
                // style="padding-left: 24px;"
              >
                <i className="ant-menu-submenu-arrow"></i>
              </div>
              <ul
                id="subCategory$Menu"
                className="ant-menu ant-menu-sub ant-menu-inline"
                role="menu"
              >
                <div className="seller-sort-list">
                  {drawerStatus.selectedSubMenu === "SORT" ? (
                    <SortByFilter
                      width="100%"
                      handleSortFilter={sortByMobile}
                      id="PLP"
                      queryParams={internalParams}
                      device="mobile"
                    />
                  ) : (
                    drawerStatus.selectedFacet.aggregateList && (
                      <CheckboxGroup
                        key={drawerStatus.selectedSubMenu}
                        {...internalParams}
                        options={drawerStatus.selectedFacet.aggregateList}
                        filterType={drawerStatus.selectedSubMenu}
                        handleChange={pageName && pageName == "search-listing" && searchBy == 'product' ? selectFilterSearch : selectFilter}
                        currency={currency}
                        selectFacetFilter={selectFacetFilter}
                        clearFacetFilter={clearFacetFilter}
                        selected="array"
                        device="mobile"
                      />
                    )
                  )}
                </div>
              </ul>
            </li>
            <li className="qa-mar-btm-2 xs-hide md-show">
              <span className="filter-title">FILTERS {" "}
              </span>
              <span className="filter-title qa-fw-n-imp">
                {filterCountMap && Object.keys(filterCountMap).length > 0 ? `(${Object.keys(filterCountMap).length})` : null}
              </span>
              <span className="clear-filter" onClick={clearFilter}>
                Clear All
              </span>
            </li>
            {orderedFacets.map((facet, key) => {
              let {
                aggregateId = "",
                aggregateName = "",
                aggregateList = [],
              } = facet;
              let except = false;
              if(aggregateId === "f_values" || aggregateId === 'values' || aggregateId === "f_material" || aggregateId === 'material'){
                except = true;
              }
              if (
                aggregateId === "f_l1_names" ||
                (aggregateId === "f_categories" && hideCatFilter) ||
                (aggregateId === "range" && !userProfile) ||
                (aggregateId === "exfactoryListPrice" && !userProfile) ||
                (aggregateId === "exfactorypricerange" && !userProfile) ||
                aggregateList.length === 0
              ) {
                // Hide Categories from Filter as it is part of facets as f_l1_name for special pages
                return <li key={`key${key}`}></li>;
              } else if (aggregateList.length > 0) {
                return (
                  <li
                    className={`ant-menu-submenu ant-menu-submenu-inline ${aggregateId} ant-menu-submenu-open xs-hide md-show`}
                    role="none"
                    key={`key${key}`}
                  >
                    <Col
                      role="menuitem"
                      className="ant-menu-submenu-title"
                      lg={18}
                      xl={19}
                      md={15}
                      tabIndex="-1"
                      aria-expanded="true"
                      aria-haspopup="true"
                      data-menu-id="rc-menu-uuid-45664-8-key0"
                      aria-controls="rc-menu-uuid-45664-8-key0-popup"
                      style={{ paddingLeft: "24px" }}
                    >
                      <div className="ant-menu-title-content">
                        {(aggregateId === "f_moqBucket" || aggregateId === "moqbucket")
                          ? "Min. order quantity"
                          : ((aggregateId === "f_values" || aggregateId === 'values' || aggregateId === "f_material" || aggregateId === 'material') ? "" : aggregateName)}
                        {!except && <span className="qa-fw-n-imp">{" "}{filterCountMap && filterCountMap[aggregateId] ? `(${filterCountMap[aggregateId]})` : null}</span>}
                      </div>
                      {(aggregateId === "range" ||
                        aggregateId === "exfactorypricerange" ||
                        aggregateId === "exfactoryListPrice") && (
                        <span
                          id="currency-currencySymbol"
                          className="pull-right"
                        >
                          {currency}
                        </span>
                      )}
                      {(aggregateId === "f_values" || aggregateId === 'values') && (
                        <span
                          id="currency-currencySymbol"
                          className="pull-right"
                          onClick={()=>{
                             setExpandValue(!expandValue) 
                          }}
                        > <span style={{marginRight:'5px'}}>{aggregateName}</span>
                          <span className="qa-fw-n-imp">{filterCountMap && filterCountMap[aggregateId] ? `(${filterCountMap[aggregateId]})` : null}</span>
                       {" "}{expandValue ? <DownOutlined /> : <UpOutlined/>}
                        </span>
                      )}
                      {(aggregateId === "f_material" || aggregateId === 'material') && (
                        <span
                          id="currency-currencySymbol"
                          className="pull-right"
                          onClick={()=>{
                         setExpandMaterial(!expandMaterial)
                          }}
                        >
                        <span style={{marginRight:'5px'}}>{aggregateName}</span>
                        <span className="qa-fw-n-imp">{filterCountMap && filterCountMap[aggregateId] ? `(${filterCountMap[aggregateId]})` : null}</span>
                       {" "}{expandMaterial ? <DownOutlined /> : <UpOutlined/>}
                        </span>
                      )}
                      {/* <i className="ant-menu-submenu-arrow"></i> */}
                    </Col>
                    <ul
                      className="ant-menu ant-menu-sub ant-menu-inline "
                      data-menu-list="true"
                    >
                      <CheckboxGroup
                        key={key}
                        {...internalParams}
                        options={aggregateList}
                        filterType={aggregateId}
                        handleChange={pageName && pageName == "search-listing" && searchBy == 'product' ? selectFilterSearch : selectFilter}
                        device="desktop"
                        currency={currency}
                        selectFacetFilter={selectFacetFilter}
                        clearFacetFilter={clearFacetFilter}
                        selected="array"
                        expandMaterial={expandMaterial}
                        expandValue={expandValue}
                      />
                    </ul>
                  </li>
                );
              }
            })}
          </Menu>
          {isMobile && (
            <div className="filter-button-section">
              <Button
                onClick={clearFilter}
                htmlType="cancel"
                className="qa-button close-button"
                loading={isLoading}
                disabled={isLoading}
              >
                Reset
              </Button>
              <Button
                htmlType="submit"
                onClick={filterSubmit}
                className="qa-button apply-button"
                loading={isLoading}
                disabled={isLoading}
              >
                Apply
              </Button>
            </div>
          )}
        </form>
      )}
    </Sider>
  );
}

const mapStateToProps = (state) => {
  return {
    userProfile: state.userProfile.userProfile,
    // currencyDetails: state.currencyConverter,
  };
};

export default connect(mapStateToProps, null )(
  ProductFacets
);